import { AreaBookingSettings } from './AreaBookingSettings'
import { EquipmentSettings } from './EquipmentSettings'
import { AreasGeneralSettingsWrapper } from './style'

interface AreasGeneralSettingsProps {
    isEditable: boolean
}

export const AreasGeneralSettings = ({
    isEditable,
}: AreasGeneralSettingsProps) => {
    return (
        <AreasGeneralSettingsWrapper>
            <AreaBookingSettings isEditable={isEditable} />
            <EquipmentSettings isEditable={isEditable} />
        </AreasGeneralSettingsWrapper>
    )
}
